module.exports = __webpack_public_path__ + "static/media/bar-brewery-winery-2.6e1a8ec6.jpg";